export default [
  {
    provider: 'vrt',
    category: 'custom',
    component_path: 'modules/sessions/sso/SsoVrtButton'
  },
  {
    provider: 'procurios',
    category: 'custom',
    component_path: 'atoms/SsoButton'
  }
]